import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { Params, RouterModule } from '@angular/router';

@Component({
  selector: 'app-nav-item',
  imports: [CommonModule, RouterModule],
  templateUrl: './nav-item.component.html',
})
export class NavItemComponent {

  icon = input<string | undefined>(undefined);
  collapsed = input<boolean>(false);
  routerLink = input<string | undefined>(undefined);
  queryParams = input<Params | undefined>(undefined);
  label = input<string | undefined>(undefined);
  tooltip = input<string | undefined>(undefined);

  click = output<Event>();
  
  onClick(event: Event) {
    this.click.emit(event);
  }
}
